export const TOKEN_PRICES_ENDPOINT = '/v3/prices/current/usd'
